exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-atb-id=notifications-sheet]{overflow:hidden!important}div:has([data-atb-id=notifications-sheet]){box-shadow:none!important}body.has-bottom-nav .notifications-sheet{z-index:850!important}body.has-bottom-nav .notifications-sheet~[role=none],body.has-bottom-nav [role=none]:has(+.notifications-sheet){z-index:849!important}.notifications-sheet-content{height:calc(100vh - 95px - var(--email-header-offset, 0px));display:flex;flex-direction:column;overflow:hidden}", ""]);

// exports
